module.exports = __webpack_public_path__ + "static/media/accreditation.251f786a.pdf";